<template src="./loading.html"></template>

<script>
    import LoadingOverlay from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        components: {
            LoadingOverlay
        },
        props: {
            isLoading: Boolean,
            fullPage: Boolean
        }
    }
</script>